/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CreateMaterialableTrackResponseData,
  CreateMaterialableTrackResponseDataFromJSON,
  CreateMaterialableTrackResponseDataFromJSONTyped,
  CreateMaterialableTrackResponseDataToJSON
} from './CreateMaterialableTrackResponseData'

/**
 *
 * @export
 * @interface PingMaterialableTrackResponse
 */
export interface PingMaterialableTrackResponse {
  /**
   *
   * @type {number}
   * @memberof PingMaterialableTrackResponse
   */
  status?: number
  /**
   *
   * @type {CreateMaterialableTrackResponseData}
   * @memberof PingMaterialableTrackResponse
   */
  data?: CreateMaterialableTrackResponseData
}

export function PingMaterialableTrackResponseFromJSON(json: any): PingMaterialableTrackResponse {
  return PingMaterialableTrackResponseFromJSONTyped(json, false)
}

export function PingMaterialableTrackResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PingMaterialableTrackResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : CreateMaterialableTrackResponseDataFromJSON(json['data'])
  }
}

export function PingMaterialableTrackResponseToJSON(value?: PingMaterialableTrackResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: CreateMaterialableTrackResponseDataToJSON(value.data)
  }
}
